export const authMap = {
  botConfig: 'bot_config',
  flowSelf: 'flow_self',
  botHistory: 'bot_history',
  pluginPublic: 'plugin_public',
  flowPublic: 'flow_public',
  homeland_chatflow: 'homeland_chatflow',
  homeland_database: 'homeland_database',
  homeland_knowledge: 'homeland_knowledge',
  homeland_long_memory: 'homeland_long_memory',
  homeland_plugin: 'homeland_plugin'
};
